var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.09209C1.25 3.98752 2.14543 3.09209 3.25 3.09209H16.75C17.8546 3.09209 18.75 3.98752 18.75 5.09209V16.75C18.75 17.8546 17.8546 18.75 16.75 18.75H3.25C2.14543 18.75 1.25 17.8546 1.25 16.75V5.09209Z",
    stroke: "#9EA9B9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 1.25V4.01316",
    stroke: "#9EA9B9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 7.5H18.75",
    stroke: "#9EA9B9",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.25V4.01316",
    stroke: "#9EA9B9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 11.25,
    width: 3.75,
    height: 3.75,
    rx: 1.875,
    stroke: "#9EA9B9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.88c83411e49d697b3d96787386f2fe46.svg";
export { ForwardRef as ReactComponent };